import { Injectable } from "@angular/core";
import { Subscription } from "rxjs";
import { AttendanceMachineApi } from "../../../shared/nestjs/gd-only/services/attendance-machine.api";
import { RequestSaveAttendanceMachineDto, ResponseListAttendanceMachineDto } from "../../../shared/nestjs/gd-only/dto/attendance-machine.dto";
import { FormDataUpload } from "../../../shared/nestjs/nest-api";
import { ResponsePaging, NestResponsesProvider } from "../../../shared/nestjs/nest-responses";

@Injectable()
export class AttendanceMachineBloc {
  public subscriptions: Array<Subscription> = [];
  constructor(
    public nestResponse: NestResponsesProvider,
    private attendanceMachineApi: AttendanceMachineApi,
  ) {
  }

  dispose() {
    this.subscriptions.forEach(subs => subs.unsubscribe());
  }

  listing(payload: { page: number, limit: number }) {
    return new Promise<ResponsePaging<ResponseListAttendanceMachineDto>>((resolve, reject) => {
      this.subscriptions.push(
        this.attendanceMachineApi.listing(payload)
          .subscribe(result => {
            resolve(result)
          }, error => {
            reject(error);
          })
      )
    })
  }

  getFileExtension() {
    return new Promise<Array<any>>((resolve, reject) => {
      this.subscriptions.push(
        this.attendanceMachineApi.getFileExtension()
          .map(res => res.data)
          .subscribe(result => {
            resolve(result)
          }, error => {
            reject(error);
          })
      )
    })
  }

  getAttendanceIdBasedOn() {
    return new Promise<Array<any>>((resolve, reject) => {
      this.subscriptions.push(
        this.attendanceMachineApi.getAttendanceIdBasedOn()
          .map(res => res.data)
          .subscribe(result => {
            resolve(result)
          }, error => {
            reject(error);
          })
      )
    })
  }

  getFieldType() {
    return new Promise<any>((resolve, reject) => {
      this.subscriptions.push(
        this.attendanceMachineApi.getFieldType()
          .map(res => res.data)
          .subscribe(result => {
            resolve(result)
          }, error => {
            reject(error);
          })
      )
    })
  }

  getTtamattmachine() {
    return new Promise<Array<any>>((resolve, reject) => {
      this.subscriptions.push(
        this.attendanceMachineApi.getTtamattmachine()
          .map(res => res.data)
          .subscribe(result => {
            resolve(result)
          }, error => {
            reject(error);
          })
      )
    })
  }

  saveAttendanceMachine(payload: RequestSaveAttendanceMachineDto) {
    return new Promise((resolve, reject) => {
      this.subscriptions.push(
        this.attendanceMachineApi.saveAttendanceMachine(payload)
          .subscribe(result => {
            resolve(result)
          }, error => {
            reject(error);
          })
      )
    })
  }

  uploadAttendanceMachine(bodies: FormDataUpload[], queryString: { machineCode: string }) {
    return new Promise((resolve, reject) => {
      this.subscriptions.push(
        this.attendanceMachineApi.uploadAttendanceMachine(bodies, queryString)
          .subscribe(result => {
            resolve(result)
          }, error => {
            reject(error);
          })
      )
    })
  }

  viewTemplateAttendanceUpload(queryString: { machineCode: string }) {
    return new Promise((resolve, reject) => {
      this.subscriptions.push(
        this.attendanceMachineApi.viewTemplateAttendanceUpload(queryString)
          .map(res => res.data)
          .subscribe(result => {
            resolve(result)
          }, error => {
            reject(error);
          })
      )
    })
  }

  downloadTemplateAttendanceUpload(queryString: { machineCode: string }) {
    return new Promise((resolve, reject) => {
      this.subscriptions.push(
        this.attendanceMachineApi.downloadTemplateAttendanceUpload(queryString)
          .subscribe(result => {
            resolve(result)
          }, error => {
            reject(error);
          })
      )
    })
  }

}



// WEBPACK FOOTER //
// ./src/bloc/hr/attendance/attendance-machine.bloc.ts